/**
 * Fetches the stop-to-lines mapping from the FlowRide backend.
 */

import axios from "axios";

import type { GeocodeTransit } from "../types/dtos/api/geocode.dto";
import type { StopLinesMappingResponseDto } from "../types/dtos/api/stop-lines.dto";

const STOP_LINES_REQUEST_TIMEOUT_MS = 10_000;

/**
 * @returns Stop id → transit lines mapping, or an empty object when the request fails.
 */
export const fetchStopLinesMapping = async(): Promise<Record<string, GeocodeTransit>> => {
    try {
        const { data } = await axios.get<StopLinesMappingResponseDto>(
            "/api/stops/lines",
            { "timeout": STOP_LINES_REQUEST_TIMEOUT_MS },
        );

        return data.lines ?? {};
    } catch( error: unknown ) {
        console.warn( "[StopLinesApi] Failed to fetch stop lines mapping", error );

        return {};
    }
};
